import { useIntl } from "react-intl";

export const useIntlId = (id) => {
  const intl = useIntl();

  return intl.formatMessage({
    id,
  });
};
